import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-900 text-white py-12 w-full" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-97">
          <div className="col-span-1 md:col-span-2" data-id="element-98">
            <div className="text-2xl font-bold mb-4" data-id="element-99">
              <span className="text-blue-400" data-id="element-100">极客</span>quant
            </div>
            <p className="text-gray-400 mb-4 max-w-md" data-id="element-101">
              专注于量化交易技术研发和策略应用的创新型金融科技公司，致力于为客户提供专业、高效的量化交易解决方案。
            </p>
            <p className="text-gray-400" data-id="element-102">
              © {new Date().getFullYear()} 极客quant. 保留所有权利.
            </p>
          </div>
          <div data-id="element-103">
            <h3 className="text-lg font-semibold mb-4" data-id="element-104">快速链接</h3>
            <ul className="space-y-2" data-id="element-105">
              <li data-id="element-106">
                <a href="#features" className="text-gray-400 hover:text-blue-400" data-id="element-107">
                  量化服务
                </a>
              </li>
              <li data-id="element-108">
                <a href="#about" className="text-gray-400 hover:text-blue-400" data-id="element-109">
                  关于我们
                </a>
              </li>
              <li data-id="element-110">
                <a href="#results" className="text-gray-400 hover:text-blue-400" data-id="element-111">
                  业绩展示
                </a>
              </li>
              <li data-id="element-112">
                <a href="#contact" className="text-gray-400 hover:text-blue-400" data-id="element-113">
                  联系我们
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-114">
            <h3 className="text-lg font-semibold mb-4" data-id="element-115">法律信息</h3>
            <ul className="space-y-2" data-id="element-116">
              <li data-id="element-117">
                <a href="#" className="text-gray-400 hover:text-blue-400" data-id="element-118">
                  隐私政策
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="text-gray-400 hover:text-blue-400" data-id="element-120">
                  服务条款
                </a>
              </li>
              <li data-id="element-121">
                <a href="#" className="text-gray-400 hover:text-blue-400" data-id="element-122">
                  风险披露
                </a>
              </li>
              <li data-id="element-123">
                <a href="#" className="text-gray-400 hover:text-blue-400" data-id="element-124">
                  监管信息
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-10 pt-6 text-sm text-gray-500" data-id="element-125">
          <p data-id="element-126">
            免责声明：量化交易涉及风险，过往业绩不代表未来表现。投资者在做出任何投资决策前，应充分了解相关风险并咨询专业意见。
          </p>
        </div>
      </div>
    </footer>;
};